var map = {
	"./0.png": 84640,
	"./1.png": 91348,
	"./10.png": 23632,
	"./11.png": 37843,
	"./12.png": 24362,
	"./13.png": 68783,
	"./14.png": 622,
	"./15.png": 36142,
	"./16.png": 60879,
	"./17.png": 84754,
	"./18.png": 34173,
	"./19.png": 54792,
	"./2.png": 42603,
	"./20.png": 18666,
	"./21.png": 96214,
	"./22.png": 14274,
	"./23.png": 33663,
	"./24.png": 11422,
	"./25.png": 58865,
	"./26.png": 51153,
	"./27.png": 69200,
	"./28.png": 56709,
	"./29.png": 36704,
	"./3.png": 83618,
	"./30.png": 81348,
	"./31.png": 29699,
	"./32.png": 92030,
	"./33.png": 68127,
	"./34.png": 76034,
	"./35.png": 38817,
	"./4.png": 24847,
	"./5.png": 49758,
	"./6.png": 10149,
	"./7.png": 85553,
	"./8.png": 6819,
	"./9.png": 66074,
	"./cursor-360.png": 5477,
	"./skeleton.png": 50822
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63141;